import { Location } from "@/interfaces/location";
import { User } from "@/interfaces/user";
import { LocationState } from "@/vuex/modules/locations/locations.types";
import { RootState } from "@/vuex/types";
import { TablePagination } from "helix-vue-components";
import { GetterTree } from "vuex";

type LocationGetter = GetterTree<LocationState, RootState>;

export const getters: LocationGetter = {
  locations(state: LocationState): Location[] {
    return state.locations;
  },
  pagination(state: LocationState): TablePagination | null {
    return state.pagination;
  },
  loading(state: LocationState): boolean {
    return state.loading;
  },
  currentLocation(state: LocationState): Location | null {
    return state.currentLocation;
  },
  users(state: LocationState): User[] {
    return state.users;
  },
  disabledMode(state: LocationState): boolean {
    return state.disabledMode;
  }
};
